

import AriaExpand from './AriaExpand';
import Promise from 'promise-polyfill';
import { throttle } from 'underscore';


const selectors = {
	button : '.js-expand-button--desktop-menu',
	content : '.js-expand-content--desktop-menu',
	desktopMenu : '.js-desktop-menu'
};


const menuItems = [];
const $desktopMenu = $(selectors.desktopMenu);


const closeMenuPromise = (menu) => {
	return new Promise(function(resolve, reject) {
		if (!menu.isOpen()) {
			resolve(); return;
		}
		menu.close(resolve);
	});
}


const closeAll = () => {
	return menuItems.map(closeMenuPromise);
}


const scrollHandler = (event) => {
	let top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
	if (top > 150) closeAll();
}


function init() {

	// close menu when scrolling past
	window.addEventListener("scroll", throttle(scrollHandler, 200), { passive: true });

	// stop click event bubbling up to close menu
	$desktopMenu.on('click', (event) => { event.stopPropagation() });

	// setup close event
	document.body.addEventListener('click', closeAll);

	// escape key
	$(document).on('keydown', function(event) {		
	 	if (event.which === 27) closeAll();
	});

	// set up menu items
	$(selectors.button).each(function() {

		let $button = $(this);
		let $content = $(this).next(selectors.content);
		if (!$button.length || !$content.length) return;

		const expand = new AriaExpand($button, $content, 'is-open', false);

		menuItems.push(expand);

		expand.toggle.addEventListener('click', function(e) {

			// close it
			if (expand.isOpen()) {
				expand.close();
				e.preventDefault();
				return false;
			}

			// otherwise close all others, and open this one
			const promises = menuItems.map(closeMenuPromise);

			Promise.all(promises).then(function() {
				expand.open();
			});

			e.preventDefault();
			return false;			
		});
	});
}


export default {
	init,
	closeAll : closeAll
}
